import { Link } from "react-router-dom";
import { Plus } from "lucide-react";
import { useWriterArticles, useSetArticlePublished } from "@/hooks/useWriter";
import { ArticleRow } from "@/components/writer/ArticleRow";
import { Button } from "@/components/ui/Button";
import { Card } from "@/components/ui/Card";
import { Skeleton } from "@/components/ui/Skeleton";

export function ArticlesPage() {
  const { data: articles, isLoading } = useWriterArticles();
  const publishMutation = useSetArticlePublished();

  return (
    <div className="max-w-3xl mx-auto px-4 py-10">
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-display font-bold">My Articles</h1>
        <Link to="/writer/articles/new">
          <Button size="sm">
            <Plus size={16} className="mr-1" /> New
          </Button>
        </Link>
      </div>

      {isLoading ? (
        <div className="space-y-4">
          {Array.from({ length: 3 }).map((_, i) => (
            <Skeleton key={i} className="h-16" />
          ))}
        </div>
      ) : !articles?.length ? (
        <Card className="p-10 text-center">
          <p className="text-grey font-body mb-4">
            You haven't written any articles yet.
          </p>
          <Link to="/writer/articles/new">
            <Button>Write Your First Article</Button>
          </Link>
        </Card>
      ) : (
        <Card className="divide-y divide-beige/10 px-4">
          {articles.map((article) => (
            <ArticleRow
              key={article.id}
              article={article}
              onTogglePublish={(id, published) =>
                publishMutation.mutate({ id, published })
              }
              publishing={publishMutation.isPending}
            />
          ))}
        </Card>
      )}
    </div>
  );
}
